<script>
  import { Bar } from 'vue-chartjs'


  export default {
    extends: Bar,
    data () {
      return {
        chartData: {
          labels: ["1948", "1967", "2015"],
          datasets: [{
            label: 'אוכלוסיה באלפים',
            borderWidth: 1,
            borderColor: [
              
              'rgba(66, 66, 66, 1)',
              'rgba(66, 66, 66, 1)',
              'rgba(66, 66, 66,1)'          
              ],
              backgroundColor: [
              
              'rgba(191, 54, 12, 0.9)', 
              'rgba(255, 143, 0, 0.9)',
               'rgba(255, 238, 88, 0.9)'     
              ],
              data: this.cData
            }]
        },
        options: {
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    props: ['cData'],
    mounted () {
      this.chartData.data = this.cData;
      this.renderChart(this.chartData, this.options)
    },
    watch: {
    cData(){
        if (this.cData.length) {
            this.renderChart({
          labels: ["1948", "1967", "2015"],
          datasets: [{
              label: 'אוכלוסיה באלפים',
              borderWidth: 1,
              borderColor: [
              
              'rgba(66, 66, 66, 1)',
              'rgba(66, 66, 66, 1)',
              'rgba(66, 66, 66,1)'          
              ],
              backgroundColor: [
              
              'rgba(191, 54, 12, 0.9)', 
              'rgba(255, 143, 0, 0.9)',
               'rgba(255, 238, 88, 0.9)'     
              ],
              data: this.cData
            }]
            }, {responsive: true, maintainAspectRatio: false})
        }else{
            this._chart.destroy()
        }
    }
}
  }
</script>